import React from "react";
import {jsonLdScript, pageSchema} from "../../helper/schema";
import BreadCrumb from "../Common/breadCrumb";
import Sidebar from "../Auth/AfterAuth/Sidebar";
import {NavLink} from "react-router-dom";
import {images} from "../../constant";
import Input from "react-phone-number-input/input";
import CommonStaticSidebar from "./commonStaticSidebar";
import BestSellerGrid from "./bestSellerGrid";
import {Helmet} from "react-helmet";
import {BASE_URL} from "../../helper";


import CustomerReviews from "../Common/CustomerReviews";
class Special_services extends React.Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <>
                <React.Fragment>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Farmer's Fresh Meat - Speciality Services</title>
                        <meta name="description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                        <meta name="robots" content="index, follow"/>
                        <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"/>
                        <meta property="og:type" content="article"/>
                        <meta property="og:title" content="Farmer's Fresh Meat - Voted Best Meat Market/Butcher Shop in Houston"/>
                        <meta property="og:description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                        <meta property="og:url" content={BASE_URL() + this.props.location.pathname}/>
                        <meta property="og:site_name" content="Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop"/>
                        <meta property="article:publisher" content="https://www.facebook.com/farmersfreshmeat"/>
                        <meta property="og:image" content={images.logoImg}/>
                        <meta property="og:image:width" content="1449"/>
                        <meta property="og:image:height" content="1024"/>
                        <meta name="twitter:card" content="summary"/>
                        <meta name="twitter:creator" content="Farmerfreshmeat"/>
                        <meta name="twitter:site" content="Farmerfreshmeat"/>
                        <link rel="canonical" href={BASE_URL() + this.props.location.pathname}/>
                        {jsonLdScript(pageSchema({type: 'WebPage', name: "Farmer's Fresh Meat - Speciality Services", pathname: this.props.location.pathname}))}
                    </Helmet>
                    <div className="about-banner mb-3">
                        <div className="image-wrap">
                            <div className="img-content">
                                <img
                                    src={images.about}
                                    alt=""
                                    className="img-fluid"
                                />
                            </div>
                            <div className="overlay"></div>
                        </div>
                        <div className="banner-content">
                            <h1 >Meet the Farmers</h1>
                            <h5>Our Speciality Services</h5>
                        </div>
                    </div>
                    <div className="container-fluid emp-form mb-fix mt-3">
                        <div className="col-12">
                            <div className="row">
                                <CommonStaticSidebar />
                                <div className="col-md-9">
                                    <div className="row justify-content-center">
                                        <div className="col-md-12 main-section bg-white mb-4">
                                            <div className="row">
                                                <div className="title pl-3 mb-3">
                                                    <h2 className="main-head">Standard Processing</h2>
                                                    <h6 className="mt-1 text-muted">All orders purchased at Farmer’s Fresh Meat are cut to order, free of charge. Want that Rib Eye steak cut extra thick for the barbeque pit? No Problem! Want those turkey wings and turkey necks cut gumbo style for that special Louisiana-style gumbo? No Problem! Want that delicious Summer Sausage cut just right to enjoy with cheddar cheese and crackers? No Problem! Our butchers and meat cutters are so experienced in the varieties of cutting that no request is too bold! Our service is a true full-service meat market from the days of old and you will soon find the experience second to none.</h6>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 main-section bg-white mb-4">
                                            <div className="row">
                                                <div className="title pl-3 mb-3">
                                                    <h2 className="main-head">Seasoning & Marinating</h2>
                                                    <h6 className="mt-1 text-muted">We can season or marinate any of the meats your purchase. Don’t want to hassle with seasoning those ribs for that weekend barbeque? Don’t worry, we will season and marinate those ribs in our commercial tumbler for you! Want that boneless chicken breast seasoned with lemon pepper? No Problem!</h6>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 main-section bg-white mb-4">
                                            <div className="row">
                                                <div className="title pl-3 mb-3">
                                                    <h2 className="main-head">Deer Processing</h2>
                                                    <h6 className="mt-1 text-muted">We process all wild game from wild hog to Deer. Just bring your game in and we’ll make fresh links from green onion to garlic, pan sausage mild or hot, you name it, we’ll do it. <b>We only charge $1.69 per pound to process your catch!</b></h6>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 text-center title mb-3 mt-3">
                                            <h2 className="main-head">Check Our Bestsellers</h2>
                                            <BestSellerGrid />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                <CustomerReviews tag="meat"/>
                </React.Fragment>
            </>
        );
    }
}

export default Special_services;



